import { TipoElementoEnum } from "../enum/tipo-elemento-enum";
import { MessaggioErroreVO } from "./messaggio-erroreVO";

export class DettaglioErroreVO {
  idElemento: string;
  tipoElementoEnum: TipoElementoEnum;
  oggetto: string;
  messaggioErrore: MessaggioErroreVO[];
}
